import React from 'react';
import {HttpPromiseState, PromiseState} from '../helpers';

interface Props {
  state: HttpPromiseState<any> | PromiseState<any> | null;
  label?: string;
  retry: () => void;
  align: 'center' | 'left' | 'right' | 'nowrap';
}

export class PromiseRetry extends React.Component<Props> {
  render() {
    let {state, label, align, retry} = this.props;

    if (state === null || !state.isRejected)
      return null;

    if (label === undefined)
      label = 'Retry';

    const child = (
      <button type="button" className="btn btn-primary"
              onClick={retry}>
        {label}
      </button>);

    switch (align) {
      case 'left':
        return (
          <div className="row">
            <div className="col-auto">
              {child}
            </div>
          </div>
        );
      case 'right':
        return (
          <div className="row justify-content-end">
            <div className="col-auto">
              {child}
            </div>
          </div>
        );
      case 'nowrap':
        return child;
      case 'center':
      default:
        return (
          <div className="row justify-content-center">
            <div className="col-auto">
              {child}
            </div>
          </div>
        );

    }
  }
}
